import { Box, Flex, Text } from '@chakra-ui/react'

import { Button } from '@/components/ui'
import { formatDateTime } from '@/utils/formatDateTime'

import { IncidentOptionI } from '../../types/types'

interface PresetIncidentCardIProps {
  presetIncident: IncidentOptionI
  onSelectNewIncident: () => void
}

export const PresetIncidentCard = ({
  presetIncident,
  onSelectNewIncident,
}: PresetIncidentCardIProps) => (
  <Flex
    border='1px solid'
    borderColor='gray.200'
    borderRadius='xl'
    direction='column'
    gap={4}
    p={6}
  >
    <Box>
      <Text color='gray.600' fontSize='xs' fontWeight={600}>
        Selected Incident
      </Text>
      <Text fontSize='2xl' fontWeight='bold' mt={1}>
        {presetIncident.incidentId}
      </Text>
      {presetIncident.createdAt && (
        <Text color='gray.500' fontSize='sm' mt={1}>
          {formatDateTime(presetIncident.createdAt)}
        </Text>
      )}
    </Box>
    <Button
      _hover={{ bg: 'purple.100' }}
      bg='purple.50'
      border='1px solid'
      borderColor='purple.200'
      color='purple.700'
      onClick={onSelectNewIncident}
      size='sm'
      variant='ghost'
    >
      Select New Incident
    </Button>
  </Flex>
)
